import config from './config.yaml';

if (config.quickSearch) {
	$('.search__input').focusin(function () {
		fillInTitles();
	});

	if ($('html').hasClass('feature-no-oninput')) { // вызов обработки поискового запроса для IE8
		$('.search .search__input').on('propertychange input', function (ev) {
			fillInTitles();
		});
	} else {
		$('.search .search__input').on('input', function () { // вызов обработки поискового запроса
			fillInTitles();
		});
	}
}

function getSearchLink(searchQuery) {
	return config.searchLink
		.replace('${rootUrl}', templateVars.siteLangRootUrlRel)
		.replace('${searchQuery}', encodeURIComponent(searchQuery));
}

function getQuickSearchLink(searchQuery) {
	return config.quickSearchLink
		.replace('${rootUrl}', templateVars.siteLangRootUrlRel)
		.replace('${searchQuery}', encodeURIComponent(searchQuery));
}

function fillInTitles() { //отправка и получение поискового запроса, отображение и скрытие формы
	const searchQuery = $('.search__input').val();
	if (searchQuery.length >= 3 && config.quickSearch) {
		$.getJSON(getQuickSearchLink(searchQuery), function (data) {
			if (data.length) {
				let searchResults = '';
				data.slice(0, config.maxElemDisplay - 1)
					.forEach((item, index) => {
						if (item.body.length) {
							searchResults += `<a href="${item.link}" class="search-result-window__items--item">${item.body}</a>`;
						} else {
							searchResults += `<a href="${item.link}" class="search-result-window__items--item">${item.title}</a>`;
						}
					});
				$('.search-result-window__items').html(searchResults);
				$('.search-result-window__all').attr('href', getSearchLink(searchQuery));
				if ($('.search-result-window:hidden').length) {
					$('.search-result-window').velocity('transition.slideDownIn', 200);
				}
			} else {
				$('.search-result-window').css('display', 'none');
			}
		});
	} else {
		$('.search-result-window').css('display', 'none');
	}
}

export function checkAndSearch(event, searchShowMessageType, $search) {
	event.preventDefault();
	const $searchInput = $search.find('.js-search-input');
	const $searchMessage = $search.find('.js-search-message');
	const text = $searchInput.val();
	if (text.length < 3) {
		setErrorState($search);
		$searchMessage.velocity(searchShowMessageType, 200);
	} else {
		unsetErrorState($search);
		doSearch(text);
	}
}

function doSearch(text) {
	window.location = getSearchLink(text);
}

// скрытие формы с результатами поиска при расфокусировке из поля ввода
$(document).on('click touchstart', function (event) {
	if (!$(event.target).closest('.js-search').length) {
		$('.search-result-window').hide();
	}
});

/**
 * Выставляет класс ошибки на указанный поисковый контейнер
 * @param $search
 */
export function setErrorState($search) {
	if ($search.length) {
		$search.addClass('is-error');
	} else {
		return false;
	}
}

/**
 * Удалаяет класс ошибки с указанного поискового контейнера
 * @param $search
 */
export function unsetErrorState($search) {
	if ($search.length) {
		$search.removeClass('is-error');
	} else {
		return false;
	}
}



// WEBPACK FOOTER //
// ./temp/components/search-form/index.js